const syncQuantityInputs = () => {
  const topQty = document.querySelector(".custom-quantity input.qty");

  if (!topQty) return;

  function syncQty() {
    const quantities = document.querySelectorAll(
      "form.cart .quantity:not(.custom-quantity) input.qty",
    );
    const bottomQty = quantities[1];
    if (bottomQty) {
      bottomQty.value = topQty.value;
    }
  }

  topQty.addEventListener("input", syncQty);

  const interval = setInterval(function () {
    const bottomQty = document.querySelector(
      "form.cart .quantity:last-of-type input.qty",
    );
    if (bottomQty) {
      syncQty();
      clearInterval(interval);
    }
  }, 100);
};

const movePrice = () => {
  const priceElement = document.querySelector(".summary .price");
  const targetElement = document.querySelector(
    ".product .summary .custom-quantity",
  );
  if (priceElement && targetElement) {
    targetElement.appendChild(priceElement);
  }
};

const triggerQuantitiUpdate = () => {
  document.querySelectorAll(".custom-number-input").forEach((wrapper) => {
    const input = wrapper.querySelector("input.qty");
    const plus = wrapper.querySelector(".plus");
    const minus = wrapper.querySelector(".minus");

    const triggerUpdate = () => {
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    };

    plus.addEventListener("click", () => {
      let step = parseInt(input.step) || 1;
      let max = parseInt(input.max) || Infinity;
      let value = parseInt(input.value) || 0;
      if (value + step <= max) input.value = value + step;
      triggerUpdate();
    });

    minus.addEventListener("click", () => {
      let step = parseInt(input.step) || 1;
      let min = parseInt(input.min) || 0;
      let value = parseInt(input.value) || 0;
      if (value - step >= min) input.value = value - step;
      triggerUpdate();
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  syncQuantityInputs();
  movePrice();
  triggerQuantitiUpdate();
});

const movePriceAndInit = () => {
  const priceElement = document.querySelector(".summary .price");
  const targetWrapper = document.querySelector(".custom-quantity");

  if (!priceElement || !targetWrapper) return;

  targetWrapper.appendChild(priceElement);

  const input = targetWrapper.querySelector("input.qty");
  const plus = targetWrapper.querySelector(".plus");
  const minus = targetWrapper.querySelector(".minus");
  const bdiPrice = targetWrapper.querySelector(".woocommerce-Price-amount");

  if (!input || !bdiPrice) return;

  let basePrice = parseFloat(
    bdiPrice.innerText.replace(/\s/g, "").replace("zł", "").replace(",", "."),
  );
  if (isNaN(basePrice)) basePrice = 0;

  const updatePrice = () => {
    const qty = parseInt(input.value) || 1;
    const newPrice = basePrice * qty;
    bdiPrice.textContent = "test";
  };

  plus.addEventListener("click", () => {
    const step = parseInt(input.step) || 1;
    const max = parseInt(input.max) || Infinity;
    let value = parseInt(input.value) || 0;
    if (value + step <= max) input.value = value + step;
    updatePrice();
  });

  //   minus.addEventListener("click", () => {
  //     const step = parseInt(input.step) || 1;
  //     const min = parseInt(input.min) || 1;
  //     let value = parseInt(input.value) || 0;
  //     if (value - step >= min) input.value = value - step;
  //     updatePrice();
  //   });
};

document.addEventListener("DOMContentLoaded", () => {
  //nie dziala
  //   movePriceAndInit();
});
